{
	"steam": {
		"linked": {
			"account-name": "Your account name is",
			"sub-title": "Congratulations! You have successfully verified the email address for your Nexon global account."
		}
	},
	"error": {
		"500": "An unknown error has occurred.",
		"form": {
			"20042": "You cannot log in to an account created from a different region. Change your region to log in.",
			"20066": "Invalid access.",
			"20068": "The code you entered is incorrect.\nPlease try again.",
			"20087": "This Twitch account is already linked to another Nexon account.",
			"20088": "A Twitch account is already linked to your Nexon account.",
			"20158": "Your social sign-in session expired.",
			"20246": "We cannot link to your account due to\nthe existence of another game record.",
			"20249": "Your session has expired due to inactivity. Try linking your account again.",
			"invalid-code": "Invalid code. Please try again.",
			"NETWORK_ERROR": "A network error occurred (Code: 20010). Please try again later.",
			"TIMEOUT": "Our API is currently not responding. This can be caused by either poor connectivity or an error with our servers.\nPlease try again in a while.",
			"code-expired": "The code has expired. Please try again.",
			"third-party-link-error": "A {name} linking API error occurred.",
			"link-auth-refused": "In order to link your {name} account, you must grant Nexon permission to read your {name} details."
		}
	},
	"close": "Close",
	"copyright": "©{0} NEXON America Inc. All Rights Reserved.",
	"languages": {
		"es": "Español (LA)",
		"en": "English",
		"pt-br": "Português (BR)",
		"de": "Deutsch",
		"fr": "Français",
		"it": "Italiano",
		"pl": "Polski",
		"tr": "Türkçe",
		"zh": "繁體中文",
		"th": "ไทย",
		"ru": "Русский",
		"nl": "Nederlands",
		"ja": "日本語",
		"ko": "한국어",
		"es-es": "Español (EU)",
		"es-mx": "Español (LA)",
		"zh-cn": "簡體中文",
		"zh-tw": "繁體中文"
	},
	"verify": "Verify",
	"instruction": {
		"activate": {
			"guide": "Go to {activateUrl} and enter this code:",
			"title": "Connect with code"
		},
		"qr-code": {
			"guide": "Scan this QR code:",
			"title": "Connect with QR code"
		},
		"title": "Choose Your Activation Method",
		"expiration-timer": "Code expires in {timer}",
		"sub-title": "Link an existing account or create a new account to complete the console account linking process.",
		"code-expired": {
			"title": "Activation Code Expired",
			"desc": "Request a new activation code and try linking your account again."
		}
	},
	"get-new-code": "Get New Code",
	"code-has-expired": "This code has expired.",
	"activation": {
		"desc": "Enter the 8-character alphanumeric code displayed on your console",
		"get-new-code-desc": "Need another code? Go back to the\nactivation page and click Get New Code.",
		"title": "ACTIVATION",
		"input-placehold": "Enter your activation code",
		"locked": {
			"desc": "Too many failed verification attempts. Try again in 24 hours.",
			"guide": "Want to Play while you wait?\nGo back to the console, restart the game,\nand then continue as a guest.",
			"title": "ACTIVATION FAILED"
		}
	},
	"your-session-has-expired": "Your session has expired.",
	"loading": "loading...",
	"session-expired": {
		"title": "Failed To Load",
		"desc": "Your session has expired. Close this browser and try linking your account again."
	},
	"in-progress": {
		"desc": "Please wait, your Nexon account is being verified.\nYou can view the results on either your console or your smart device.",
		"title": "Account Verification In Progress..."
	},
	"success-page": {
		"desc": "Your account is now linked. Close this browser to return to your game.",
		"title": "SUCCESS!",
		"desc-for-new-account": "Your new account is now linked. Close this browser to return to your game.\nTo complete your account creation and set up other benefits,\ngo to Nexon.com and log in to your account."
	},
	"linked": {
		"title": "ACCOUNT LINKED",
		"sub-title": "Congratulations!",
		"desc1": "You have successfully verified the email address\nfor your Nexon global account.",
		"desc2": "Go back to your console to resume gameplay.",
		"desc-for-new-account": "To complete your account creation and set up\nother benefits, go to Nexon.com and\nlog in to your account.",
		"desc2-for-new-account": "Please RETURN to the GAME by console."
	},
	"failed": {
		"title": "ACCOUNT LINKING FAILED",
		"desc": "We cannot log you in due to\nan unexpected error. Try again later.",
		"bottom": "Close this page to return to your game.",
		"already-linked": {
			"desc1": "We cannot link to your account due to\nthe existence of another game record."
		},
		"contact-cs": "Please contact customer service.",
		"title-pc": "Failed To Link",
		"user-cancel": {
			"desc1": "Failed to link your Nexon account.",
			"desc2": "Account-linking may fail if you've closed the waiting screen that appears when you try to link your account.",
			"desc3": "Please link your account without closing the account-linking waiting screen."
		},
		"nexon-account-already-linked": {
			"desc1": "This Nexon account is linked to a different {platformType} account.\n",
			"desc2": "Please check the account information linked to your Nexon account.",
			"desc3": "If you wish to link the current {platformType} account to the Nexon account, please unlink the existing connection to your Nexon account and try again."
		},
		"external-platform-already-linked": {
			"desc1": "The connected {platformType} account is linked to a different Nexon account.\n",
			"desc2": "Please check the Nexon account information linked to your {platformType} account.\n",
			"desc3": "If the issue persists, please contact Nexon Customer Support."
		}
	},
	"delink": "Delink",
	"link": "Link",
	"are-you-sure": "Are you Sure?",
	"cancel-link": {
		"desc": "Your linking process will be stopped\nif you click the confirm button.\nPlease restart the game again if you want to play game."
	},
	"confirm": "CONFIRM",
	"cancel": "CANCEL",
	"setting": {
		"delink-confirmation": {
			"title": "Delink Third-Party Account",
			"desc": "You are now delinking your Nexon account."
		},
		"title": "3rd Party Connection",
		"linked-to": "Linked to {platformUserName}",
		"not-linked": "Not Linked",
		"external-connections": "External Connections",
		"link-won-be-updated": "Clicking link/delink directs you to an external website. After following the on-screen instructions, refresh this page to verify the results.",
		"how-to-link": {
			"console": "A console device is required for account linking.\n\nOpen a Nexon game from your console and follow the on-screen instructions to complete the account linking process.",
			"steam": "A Steam account and the Steam application are both required for account linking. \n\nOpen a Nexon game from the Steam application using your Steam account and follow the on-screen instructions to complete the account linking process."
		},
		"twitch-relink-message": "Your Twitch account link has been revoked or expired. This may happen after changing your Twitch password. Click \"Link\" in the Twitch Third-Party Apps section below to relink.",
		"authorized-apps-and-services": "authorized apps & services",
		"community-relink-message": "Your {platformType} account link has been revoked or expired. This may happen after changing your {platformType} password. Click \"Link\" in the {platformType} Third-Party Apps section below to relink."
	},
	"to-try-again-close-this-browser": "To try again, close this browser.",
	"dialog": {
		"title": {
			"notice": "Notice",
			"error": "Error",
			"success": "Success"
		}
	},
	"third-party-link-success-desc": "Your {name} account was successfully linked to your Nexon account.",
	"how-to-link": "How to Link",
	"coming-soon": "Coming Soon",
	"platform": {
		"psn": "PlayStation™Network",
		"xbox": "Microsoft",
		"steam": "Steam",
		"twitch": "Twitch",
		"discord": "Discord",
		"nintendo": "Nintendo"
	},
	"overlink": {
		"already-linked": {
			"title": "Already Linked",
			"info": "<p>Your {platformType} account is already linked to another Nexon account.</p>\n<p>Linking the current Nexon account will unlink your {platformType}&nbsp;account with other Nexon accounts.</p>\n<p>To continue, click <strong>Link Account</strong> below.</p>",
			"success": "<p>Your {platformType}&nbsp;account is now linked to your Nexon account. Any claimed Nexon-{platformType}&nbsp;Drops rewards will be granted to this Nexon account only.</p>\n<p>Important: {platformType}&nbsp;Drops rewards cannot be transferred from one Nexon account to another.</p>",
			"link-account": "Link Account",
			"dnf-info": "This {platformType} account is already linked to a DFO ID.\nIf you link it to the currently logged-in Nexon account, it will be de-linked from the DFO ID.\nContinue?",
			"dnf-title": "Linked DFO ID Exists"
		},
		"error": {
			"title": "Session Expired"
		}
	},
	"move-to-link": "Move To Link",
	"user-only": "User Only",
	"conflict": {
		"title": "Game Data Exists",
		"desc1": "Game data exists on the Nexon account that you've logged into.",
		"desc2": "You can select the game data you want to play when restarting the game after linking your account.",
		"desc3": "You will only be able to access your data on the Nexon account.",
		"confirm-desc": "Do you confirm the above and want to proceed with the account linking?",
		"confirm": "Link Account"
	},
	"web-linking": {
		"error": {
			"linking-failed": "Account-linking Failed",
			"failed-unexpectedly": "There was an unexpected error linking your account.",
			"try-again": "Please try again.",
			"data-conflict": {
				"desc": "The {platformType} account is already linked to another Nexon account. Can't proceed with account linking."
			},
			"delinking-failed": "Account Unlinking Failed",
			"delinking-failed-unexpectedly": "There was an unexpected error unlinking your account.",
			"already-linked": "A {platformType} account is already linked to your Nexon account.",
			"timeout": "The wait time has expired.",
			"try-again-linking": "Please try linking again.",
			"linking-waiting-desc1": "The {targetPlatform} account is in a pending link state.",
			"linking-waiting-desc2": "While the link is pending, the account can only be linked to the {oppositePlatform} account that was previously used for the attempt.",
			"linking-waiting-desc3": "To link a different {oppositePlatform} account, please wait until the validity period has expired.",
			"linking-waiting-desc4": "Linkage pending status is valid for up to 10 minutes."
		},
		"success": {
			"linking-completed": {
				"title": "Account Link Complete",
				"desc1": "{platformType} account and Nexon account are linked.",
				"desc2": "You will only be able to access your data on the Nexon account."
			},
			"delinking-completed": {
				"title": "Account Unlinking Succeeded",
				"desc": "Your Nexon account has been unlinked from your {platformType} account."
			}
		},
		"info": "Info",
		"confirm-delinking": {
			"title": "The {platformType} account is linked to a Nexon account.",
			"desc1": "Unlinking your account will prevent you from using features that require account linking.",
			"desc2": "Unlink account?"
		},
		"delink": "Unlink",
		"confirm-delinking-community": {
			"desc1": "If you withdraw your consent from the \"Authorized Apps\" menu in your {platformType} user settings and return to this page, your account connection will be removed.",
			"desc2": "Do you wish to disconnect your account?\n"
		},
		"confirm-delinking-discord": {
			"desc1": "If you revoke consent from the Authorized Apps menu in your Discord user settings and return to this page, your account link will be removed. Do you want to unlink your account?"
		}
	},
	"bidi-linking": {
		"title": "Account Link Guide",
		"guide-message-1": "Link requests will be processed one by one in order.",
		"guide-message-2": "During the linking process, each service's consent screen will appear once, both sides must agree for the link to complete.",
		"guide-message-3": "Your information is securely protected and will not be linked without your consent.",
		"cta-message": "To continue, press the button below.",
		"button-continue-text": "Continue Account Linking"
	}
}